<template>
    <div class="mt-10">
        <v-subheader class="text-h6 px-0 mt-4 mb-2">
            Manage Conditions
        </v-subheader>
        <div>

            <slot name="additional-conditions" />

            <v-row no-gutters v-for="(conditions, groupIndex) in conditionsData"
                :key="groupIndex"
                class="mb-4">
                <v-col cols="12">
                    <v-card>
                        <v-card-title class="d-flex justify-between align-center">
                            <span>{{ groupIndex == 0 ? 'If' : 'And if' }}</span>
                            <v-btn
                                v-if="groupIndex > 0"
                                icon
                                class="ml-auto close-btn"
                                @click="removeGroupCondition(groupIndex)">
                                <i class="fa fa-times-circle fa-2x"></i>
                            </v-btn>
                        </v-card-title>
                        <v-card-text>
                            <div class="subtitle-1 mb-2">any of the following conditions is true...</div>

                            <div v-for="(condition, index) in conditions" :key="index" class="d-flex align-center mb-2">
                                <v-col class="pl-0 pr-1">
                                    <v-select
                                        v-model="condition.fieldName"
                                        :items="fields"
                                        item-value="value"
                                        item-text="text"
                                        menu-props="auto"
                                        label="Field"
                                        dense
                                        clearable
                                    >
                                    </v-select>
                                </v-col>

                                <v-col class="pl-0 pr-1" v-if="condition.fieldName == 'request-data-field' || condition.fieldName == 'route-data-field'">
                                    <v-text-field
                                        label="Custom Field"
                                        v-model="condition.customField"
                                        dense/>
                                </v-col>

                                <v-col class="px-1">
                                    <v-select
                                        :items="operators"
                                        v-model="condition.operator"
                                        @change=" IsValueDisabled(condition.operator) ? condition.value = '' : condition.value "
                                        label="Operator"
                                        clearable
                                        dense>
                                    </v-select>
                                </v-col>

                                <v-col class="px-1">
                                    <v-text-field
                                        :disabled="IsValueDisabled(condition.operator)"
                                        label="Value"
                                        v-model="condition.value"
                                        dense/>
                                </v-col>

                                <v-col cols="1" class="d-flex align-center justify-end pl-1 pr-0">
                                    <v-btn
                                        x-small
                                        class="mr-1"
                                        @click="addConditionRow(groupIndex, index)">
                                        +
                                    </v-btn>
                                    <v-btn
                                        x-small
                                        @click="removeConditionRow(groupIndex, index)"
                                        :disabled="conditions.length === 1">
                                        -
                                    </v-btn>
                                </v-col>
                            </div>

                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>

            <v-row no-gutters>
                <v-col cols="12">
                    <div class="my-3">
                        <v-btn small @click="addGroupCondition">Add condition</v-btn>
                    </div>
                </v-col>
            </v-row>
        </div>

    </div>
</template>

<script>
import { ShippingOptionConditionStruct } from '@/js/components/integrations/tabs/liverate-settings/shipping-options/ShippingOptionStruct.js';
import { STANDARD_OPERATORS } from '@/js/constants/operators'
export default {
    props: {
        conditions: {
            type: Array,
            required: true
        },
        showIncludeOption: {
            type: Boolean,
            default: true
        },
        additionalFields: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            conditionsData: this.conditions,
            fields: [
                ...[
                    // standard items fields
                    { header: 'MachShip Fields' },
                    {
                        'text': 'fromLocationId',
                        'value': 'ms-fromLocationId'
                    },
                    {
                        'text': 'fromAddressLine1',
                        'value': 'fromAddressLine1'
                    },
                    {
                        'text': 'fromAddressLine2',
                        'value': 'fromAddressLine2'
                    },
                    {
                        'text': 'fromLocation.suburb',
                        'value': 'fromLocation.suburb'
                    },
                    {
                        'text': 'fromLocation.postcode',
                        'value': 'fromLocation.postcode'
                    },
                    {
                        'text': 'toLocationId',
                        'value': 'toLocationId'
                    },
                    {
                        'text': 'toAddressLine1',
                        'value': 'toAddressLine1'
                    },
                    {
                        'text': 'toAddressLine2',
                        'value': 'toAddressLine2'
                    },
                    {
                        'text': 'toLocation.suburb',
                        'value': 'toLocation.suburb'
                    },
                    {
                        'text': 'toLocation.postcode',
                        'value': 'toLocation.postcode'
                    },
                    {
                        'text': 'carrierIds',
                        'value': 'carrierIds'
                    },
                    {
                        'text': 'questionIds',
                        'value': 'questionIds'
                    },

                    { header: 'Product Fields' },
                    {
                        'text': 'Product SKUs',
                        'value': 'product-skus'
                    },
                    {
                        'text': 'Product Names',
                        'value': 'product-names'
                    },
                    {
                        'text': 'Product itemTypes',
                        'value': 'product-itemTypes'
                    },

                    { header: 'Item Fields' },
                    {
                        'text': 'Item SKUs',
                        'value': 'item-skus'
                    },
                    {
                        'text': 'Item Names',
                        'value': 'item-names'
                    },
                    {
                        'text': 'Item itemTypes',
                        'value': 'item-itemTypes'
                    },
                    {
                        'text': 'Max Item Weight',
                        'value': 'max-weight'
                    },
                    {
                        'text': 'Min Item Weight',
                        'value': 'min-weight'
                    },
                    {
                        'text': 'Total Item Weight',
                        'value': 'total-item-weight'
                    },

                    { header: 'Order Fields' },
                    {
                        'text': 'Total Cubic',
                        'value': 'total-cubic'
                    },
                    {
                        'text': 'Total Weight',
                        'value': 'total-weight'
                    },
                    {
                        'text': 'Total Quantity',
                        'value': 'total-quantity'
                    },
                    {
                        'text': 'Total Price',
                        'value': 'total-price'
                    },

                    { header: 'Request Data' },
                    {
                        'text': 'Request Data Payload',
                        'value': 'request-data-payload'
                    },
                    {
                        'text': 'Request Data Field',
                        'value': 'request-data-field'
                    },

                    { header: 'Others' },
                    {
                        'text': 'Address Is PO Box',
                        'value': 'address-is-po-box'
                    }
                ],
                ...this.additionalFields

            ],
            operators: STANDARD_OPERATORS,
        };
    },

    methods: {

        addGroupCondition() {
            this.conditionsData.push([new ShippingOptionConditionStruct({})]);
        },

        removeGroupCondition(index) {
            this.conditionsData.splice(index, 1);
        },

        addConditionRow(groupIndex, rowIndex) {
            this.conditionsData[groupIndex].splice(rowIndex + 1, 0, new ShippingOptionConditionStruct({}));
        },
        removeConditionRow(groupIndex, rowIndex) {
            this.conditionsData[groupIndex].splice(rowIndex, 1);
        },

        IsValueDisabled(operator) {
            return ['Is Empty', 'Is True', 'Is False'].includes(operator);
        }
    },

    watch: {
        conditions: {
            handler(newVal) {
                this.conditionsData = newVal; // re-assign on prop change
            },
            deep: true,
            immediate: true
        }
    }
};
</script>
